var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    borderWidth: borders.widthMedium,
    borderColor: colors.contrasts.grey1111,
    categoryDescriptionBackground: colors.contrasts.grey1111,
    categoriesWrapperPadding: spacing.xSmall,
    categoriesContainerPadding: spacing.xSmall,
    categoryContainerWrapperPadding: spacing.xSmall,
    categoryDescriptionInputPadding: spacing.xSmall,
    categoryBodyAnswersPadding: spacing.xSmall,
    itemContainerPadding: spacing.xSmall,
    itemContainerBodyPadding: spacing.xxSmall
  };
};
export default generateComponentTheme;